import { motion } from "framer-motion";
import React from "react";
import { ThemeType } from "../util/types";
import DynamicText from "./DynamicText";

const PlayerReminder = ({
  reminder,
  theme,
}: {
  reminder: string;
  theme: ThemeType;
}) => {
  return (
    <motion.div
      animate={{ scale: [0.8, 1.2, 0.8] }}
      transition={{ repeat: Infinity, damping: 10, duration: 2.5 }}
    >
      <DynamicText
        style={{
          color: theme.ReminderColor,
          fontSize: 15,
          width: "100%",
          justifyContent: "center",
        }}
      >
        {reminder}
      </DynamicText>
    </motion.div>
  );
};

export default PlayerReminder;
